import { FlipFlop } from './../../../utils/index.js';

export const requirements = {
  flipFlopRequirements: [],
};

export const verifier = () => FlipFlop.get('credit-portal-beta', false);
